import React, { useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";
import { fetchHotdeals } from "../services/nonAuthRequets";
import { S3_URL_PRODUCTS } from "../utils/constants";
import { AuthContext } from "../contexts/AuthContext";
import { addToWishlist } from "../services/authenticatedRequests";
import { toast } from "react-toastify";
import ProductCards from "./ProductCards";
import PaginateComponent from "./PaginateComponent";
import LoadingComponent from "./LoadingComponent";
import NoResultsComponent from "./NoResultsComponent";
const HotDeals = () => {
  document.title = "Hot Deals | Bigmall";
  const { isAuthenticated, logout, user } = useContext(AuthContext);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [isWishlistSubmitting, setIsWishlistSubmitting] = useState(false);
  const pageSize = 18;

  const fetchProducts = async (page = 0) => {
    setLoading(true);
    try {
      
      const data = await fetchHotdeals(page, pageSize);
      setTotalPages(data.totalPages);
      // setProducts((prevProducts) => {
      //   const updatedProducts = [...prevProducts, ...data.content];
      //   return Array.from(
      //     new Map(updatedProducts.map((p) => [p.id, p])).values()
      //   );
      // });
      setProducts(data.content);
    } catch (error) {
      console.error("Error searching products:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts(currentPage);
  }, [currentPage]);

  // const loadMoreProducts = () => {
  //   if (currentPage < totalPages - 1) {
  //     setCurrentPage(currentPage + 1);
  //     fetchProducts(currentPage + 1);
  //   }
  // };

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (loading) {
    return <LoadingComponent message="Loading products..." />;
  }
  if (products.length === 0) {
    return <NoResultsComponent message="No products found" />;
  }
  return (
    <>
    <ProductCards
      products={products}
      currentPage={currentPage}
      totalPages={totalPages}
      //loadMoreProducts={loadMoreProducts}
      showLoadmore={false}
      title="🔥Hot Deals"
    />
    <div className="container">
        <PaginateComponent
          totalPages={totalPages}
          handlePageClick={handlePageClick}
          currentPage={currentPage}
        />
      </div>
    </>
    
    // <div className="product mt-24">
    //   <div className="container container-lg">
    //     <div className="row gy-4 g-12">
    //       {loading ? (
    //         <div className="text-center py-4">
    //           <h5 className="text-muted">Loading Products....</h5>
    //         </div>
    //       ) : products.length > 0 ? (
    //         products.map((product) => (
    //           <div
    //             className="col-xl-2 col-lg-3 col-sm-4 col-6"
    //             key={product.id}
    //           >
    //             <div className="product-card px-8 py-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">
    //               {isAuthenticated && (
    //                 <button
    //                   disabled={isWishlistSubmitting}
    //                   onClick={() => handleAddToWishlist(product.id)}
    //                   className={`product-card__cart btn bg-main-50 text-main-600 hover-bg-main-600 hover-text-white py-11 px-24 rounded-pill flex-align gap-8 position-absolute inset-block-start-0 inset-inline-end-0 me-16 mt-16 ${
    //                     isWishlistSubmitting
    //                       ? "opacity-50 cursor-not-allowed"
    //                       : ""
    //                   }`}
    //                 >
    //                   {isWishlistSubmitting ? (
    //                     <i className="ph ph-spinner animate-spin" /> // Loading icon
    //                   ) : (
    //                     <i className="ph ph-heart" />
    //                   )}
    //                 </button>
    //               )}
    //               <Link
    //                 to={`/product-details/${product.id}`}
    //                 className="product-card__thumb flex-center"
    //               >
    //                 <img
    //                   src={`${S3_URL_PRODUCTS}${product.images?.[0]}`}
    //                   alt={product.name}
    //                 />
    //               </Link>

    //               <div className="product-card__content">
    //                 <h6 className="title text-sm fw-semibold">
    //                   <Link
    //                     to={`/product-details/${product.id}`}
    //                     className="link text-line-2"
    //                     title={product.name}
    //                   >
    //                     {product.name.length > 20
    //                       ? `${product.name.slice(0, 20)}...`
    //                       : product.name}
    //                   </Link>
    //                 </h6>
    //                 <div className="product-card__price">
    //                   {product.salePrice ? (
    //                     <>
    //                       <div className="d-flex align-items-center gap-4">
    //                         <span className="text-gray-400 text-sm fw-semibold text-decoration-line-through">
    //                           LKR{product.regularPrice.toFixed(2)}
    //                         </span>
    //                         <span className="badge bg-main-600 text-white text-sm fw-semibold">
    //                           -
    //                           {Math.round(
    //                             ((product.regularPrice - product.salePrice) /
    //                               product.regularPrice) *
    //                               100
    //                           )}
    //                           %
    //                         </span>
    //                       </div>
    //                       <span className="text-heading text-sm fw-semibold">
    //                         LKR{product.salePrice.toFixed(2)}
    //                       </span>
    //                     </>
    //                   ) : (
    //                     <span className="text-heading text-sm fw-semibold">
    //                       LKR{product.regularPrice.toFixed(2)}
    //                     </span>
    //                   )}
    //                 </div>
    //               </div>
    //             </div>
    //           </div>
    //         ))
    //       ) : (
    //         <div className="text-center py-4">
    //           <h5 className="text-muted">No products found....</h5>
    //         </div>
    //       )}
    //     </div>

    //     {/* Load More Button */}
    //     <div className="mt-16 d-flex justify-content-center">
    //       {currentPage < totalPages - 1 ? (
    //         <button
    //           onClick={loadMoreProducts}
    //           className="btn bg-main-600 text-white py-11 px-24 rounded-pill"
    //         >
    //           {loading ? "Loading..." : "Load More"}
    //         </button>
    //       ) : (
    //         <div className="text-center py-4">
    //           <h5 className="text-muted">No more products to show</h5>
    //         </div>
    //       )}
    //     </div>
    //   </div>
    // </div>
  );
};

export default HotDeals;
